module.exports = __webpack_public_path__ + "static/media/note.05872feb.svg";